"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberSearchQueryField = void 0;
var _simpleSearchQueryField = require("./simple-search-query-field");
class NumberSearchQueryField extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, value, defaultValue) {
    super(searchOptions, NumberSearchQueryField.parse(value), defaultValue);
  }
  getUrlParameterValue() {
    return this.isDefault() ? null : "".concat(this.internalValue);
  }
  static parse(value) {
    if (value == null) {
      return null;
    }
    var parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
}
exports.NumberSearchQueryField = NumberSearchQueryField;